export default __webpack_public_path__ + "static/media/img1.aa4186c8.svg";